<template>
  <modal size="lg" @close="$emit('close')">
    <div class="w-full flex flex-wrap">
      <div class="w-full mb-2">
        <nx-input type="url" v-model="url" label="Link URL" id="url" :focus="true" />
      </div>
      <div class="w-full">
        <nx-button
          :disabled="!valid"
          @click="$emit('success', url)"
        >{{ edit ? 'Update Link' : 'Insert Link'}}</nx-button>
        <nx-button
          class="ml-2"
          type="secondary"
          v-if="edit"
          @click="$emit('success', null)"
        >Remove Link</nx-button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: "RichTextLinkModal",
  props: {
    existing: {
      default: {}
    }
  },
  data() {
    return {
      url: "",
      edit: false,
      pattern: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/
    }
  },
  computed: {
    valid() {
      return this.pattern.test(this.url)
    }
  },
  mounted() {
    if (this.existing.href) {
      this.edit = true
      this.url = this.existing.href
    }
  }
}
</script>
